import { api } from '@/api'
import { makeAutoObservable } from 'mobx'
import { useEffect, useState } from 'react'

export class UserService {
  public userInfo: Models.UserInfo | null | undefined = undefined
  constructor() {
    makeAutoObservable(this)
  }

  public async refreshUserInfo() {
    const { data } = await api.auth.me().send(true)
    this.userInfo = data
  }

  public async getUserInfo(force: boolean = false) {
    if (force) {
      const { data } = await api.auth.me().send(true)
      this.userInfo = data
    }
    return this.userInfo
  }

  public async logout() {
    await api.auth.logout().send(true)
    this.userInfo = null
  }
}

export const userService = new UserService()

export const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState<Models.UserInfo | null | undefined>(undefined)

  useEffect(() => {
    userService.refreshUserInfo()
  }, [])

  useEffect(() => {
    setUserInfo(userService.userInfo)
  }, [userService.userInfo])

  return userInfo
}
